"use strict";
exports.__esModule = true;
exports.checkpassword = void 0;
exports.checkpassword = function (password) {
    var strength = 0;
    if (password.match(/[a-z]+/)) {
        strength += 1;
    }
    if (password.match(/[A-Z]+/)) {
        strength += 1;
    }
    if (password.match(/[0-9]+/)) {
        strength += 1;
    }
    if (password.match(/[^A-Za-z0-9]/)) {
        strength += 1;
    }
    return strength;
};
